<div class="tf-price-header-ctnr">

    <div class="tf-price-header-not-logged" *ngIf="!isLoggedIn()">
        <div class="price-label tf-font-medium">Price <ng-container *ngIf="showCurrency()">({{getCurrency()}})</ng-container></div>

        <ng-template #loginContent>
            <a class="tf-log-in" (click)="signIn()">Sign in</a> now to see<br> your best price
        </ng-template>

        <div class="tf-ng-popover" [ngbPopover]="loginContent" placement="top" container="body"
             popoverClass="tf-ngb-popover tf-log-in-popover">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 16 16">
                <path
                    d="M9,4c2.8,0,5,2.2,5,5s-2.2,5-5,5s-5-2.2-5-5S6.2,4,9,4 M9,2C5.1,2,2,5.1,2,9s3.1,7,7,7s7-3.1,7-7 c0-1.9-0.7-3.6-2.1-4.9S10.9,2,9,2z M8,8.5v4.4h2V8.5H8z M8,5.2v2h2v-2H8z"/>
            </svg>
        </div>
    </div>

    <div class="tf-price-header-logged" *ngIf="isLoggedIn()">
        <div>Your Price <ng-container *ngIf="showCurrency()">({{getCurrency()}})</ng-container></div>
    </div>

</div>
